import { render, staticRenderFns } from "./ExemptPE.vue?vue&type=template&id=06345b9e&scoped=true&"
import script from "./ExemptPE.vue?vue&type=script&lang=js&"
export * from "./ExemptPE.vue?vue&type=script&lang=js&"
import style0 from "./ExemptPE.vue?vue&type=style&index=0&id=06345b9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06345b9e",
  null
  
)

export default component.exports